import React, { FC } from 'react';
import {Icon} from '../icons/icons';

interface LevelIconProps {
   iconName:string,
   iconClassNames: Array<string>,
   levelText:string,
   levelTextClassNames: Array<string>,
   detailText:string,
   detailTextClassNames: Array<string>
   iconColor?:string
}

const LevelIcon: FC<LevelIconProps> = ({ iconName, iconClassNames, levelText, levelTextClassNames, detailText, detailTextClassNames, iconColor }) => {

   return (
      <>
         <Icon style={{color:iconColor}} name={iconName} className={iconClassNames.join(' ')} />
         <div className={levelTextClassNames.join(' ')}>{levelText}</div>
         <div className={detailTextClassNames.join(' ')}>{detailText}</div>
      </>
   )
};

export default LevelIcon;